import React from "react";
import { toastService } from "../../services/toastService";
import { CreateCardPaymentMethodRequest, CreateIbanPaymentMethodRequest, CreateNonIbanPaymentMethodRequest } from "../../models/MerchantModel";
import { Dialog } from "primereact/dialog";
import { merchantPaymentMethodApiService } from "../../services/api/merchants/MerchantPaymentMethodApiService";
import { AddBank } from "../Banking/AddBank";
import { AddNonIBAN } from "../Banking/AddNonIBAN";

interface AddMerchantPaymentMethodProps {
    onHide: () => void;
    merchantId: number;
    paymentMethodType: "Bank" | "NonIBAN";
}

interface AddMerchantPaymentMethodState {
    isSubmitting: boolean;
}

export class AddMerchantPaymentMethod extends React.Component<AddMerchantPaymentMethodProps, AddMerchantPaymentMethodState> {
    constructor(props: AddMerchantPaymentMethodProps) {
        super(props);

        this.state = {
            isSubmitting: false,
        };
    }

    onSuccess = async (item: CreateCardPaymentMethodRequest | CreateIbanPaymentMethodRequest | CreateNonIbanPaymentMethodRequest) => {
        this.setState({ isSubmitting: true });
        const result = await merchantPaymentMethodApiService.create(this.props.merchantId, item);
        this.setState({ isSubmitting: false });

        if (result.success) {
            this.props.onHide();
        } else {
            toastService.error(result.message);
        }
    };

    render() {
        const title = this.props.paymentMethodType === "Bank" ? "Add Bank Account" : "Add Non-IBAN Account";

        return (
            <Dialog header={title} visible={true} style={{ width: "40rem" }} onHide={this.props.onHide}>
                {this.props.paymentMethodType === "Bank" ? (
                    <AddBank
                        isSubmitting={this.state.isSubmitting}
                        selectedMerchantId={this.props.merchantId}
                        OnSuccess={this.onSuccess}
                    />
                ) : (
                    <AddNonIBAN
                        isSubmitting={this.state.isSubmitting}
                        OnSuccess={this.onSuccess}
                    />
                )}
            </Dialog>
        );
    }
}
